import React, { Component } from 'react';
import * as util from './util';
import { Header } from './header.js';
import { Footer } from './footer.js';
import { CategorySelectorList } from './category-selector-rewrite';
import { logBusinessActivities } from './business_activities';
import {
  TextInfo, TextLine, TextField, Selection, Tags,
  CheckBox, AGBCheckBox, SubmitButton, MultipleFileUpload
} from './common-form-components.js';
import { FeeBoxXU } from './feebox-xu';

import './tender.css';

let faqTender = [];
var introductoryText = '<p>Ausschreibungen im Klinikbereich können sehr aufwändig in der Beantwortung sein. Und viele Antworten auf Ausschreibungen beinhalten neue Konzepte, die auch für andere Kliniken interessant sein können. <br /><br />Hier können Sie, wenn Sie eine Ausschreibung beantwortet haben, das Paket entlang des Leistungsumfangs erneut anbieten. In den meisten Fällen wird es sich um finanzielle Größenordnungen handeln, die eine erneute Ausschreibung eines neuen Kunden erfordern. Jedoch kann es für Sie einen großen Vorteil bieten, wenn Ihr entwickeltes Konzept die Grundlage für eine neue Ausschreibung bildet. Und: Sie kommen ins Gespräch mit möglichen neuen Kunden. Die sich bewusst ihr Konzept ansehen.<br/><p> Eine kleine Anzahl der Felder sind mit einem "*" gekennzeichnet und <u>müssen</u> ausgefüllt werden. Alle weiteren Felder sind freiwillig. Diese können für mögliche Kunden von Interesse sein.</p>';

var tenderTypes = [
  <option key='6'>bitte wählen...</option>,
  <option key='0'>Kliniken</option>,
  <option key='1'>Praxen</option>,
  <option key='2'>MVZ</option>,
  <option key='3'>Kleingruppen</option>,
  <option key='4'>Einzelpersonen</option>,
  <option key='5'>sonstige/keine Auslegung</option>
];

export class CreateTender extends Component {
  constructor(props) {
    super(props);
    this.fetchDataAndRedirect = this.fetchDataAndRedirect.bind(this);
    this.fetchDataAndRedirect();
  }

  fetchDataAndRedirect() {
    const self = this;
    var headers = util.defaultHeaders();
    headers.append("Accept", "application/json");
    headers.append('Content-Type', 'application/x-www-form-urlencoded');
    var url = `/api/create-tender`;
    var promise = fetch(url, {
      method: 'POST',
      headers: headers,
      body: ''
    })
      .then(response => response.json())
      .catch(function (exception) {
        alert('Konnte keine Ausschreibung anlegen!');
        console.error(`Could not create tender!`, exception);
      });
    promise.then(function (json) {
      self.props.history.replace(`/update-tender/${json.id}`);
    });
  }

  render() {
    return (
      <div className="CreateTender">
      </div>
    )
  }
}

export class UpdateTenderWithFeebox extends Component {
  constructor(props) {
    super(props);
    this.updateFeeByCategories = this.updateFeeByCategories.bind(this);
    this.countCategories = this.countCategories.bind(this);
    this.state = {
      price: 0,
      categoryCount: 1
    };
  }

  updateFeeByCategories(categories) {
    this.setState({ categoryCount: this.countCategories(categories) });
    return true;
  }


  countCategories(categories) {
    // workaround: converting String to array (FIXME)
    if ((typeof categories ) === 'string') {
      categories = categories.split(",");
    }
     console.log(categories);
     var tempCats = [];
     var count = 0;
     for (let i = 0; i < 6; i++) {
      if (categories !== undefined && categories[i] !== null && categories[i] !== "" ) {
        if (!tempCats.includes(categories[i])) {
          tempCats.push(categories[i]);
          count = count+1;
        } 
      }
    }
    return count;
  }


  render() {
    return (
      <div className="UpdateTenderWithFeebox" >
        <UpdateTender history={this.props.history} match={this.props.match} updateFeeByCategories={this.updateFeeByCategories}
          onNewMessage={alert} />
        {util.isCommercialUser() &&
          <FeeBoxXU type="tender" categoryCount={this.state.categoryCount} feeStepConst="400" />}
      </div>
    )
  }
}

export class UpdateTender extends Component {
  constructor(props) {
    super(props);
    this.fetchDataAndRedirect = this.fetchDataAndRedirect.bind(this);
    this.update = this.update.bind(this);
    this.validateInput = this.validateInput.bind(this);
    this.checkRequiredFields = this.checkRequiredFields.bind(this);
    this.isValid = this.isValid.bind(this);
    this.save = this.save.bind(this);

    this.state = {
      startID: 2,
      id: null,
      name: '',
      categories: '',
      description: '',
      price: '',
      target_group: '',
      aim: '',
      tags: '',
      agb_agreement: false,
      pdf_files: ',,,,',
      image_files: ',,,,,,,,,',
      video_files: '',
      product_files: '',
      agreement_1: false,
      agreement_2: false,
      agreement_3: false,
      agreement_4: false,

    };

    this.fetchDataAndRedirect();
    this.globalFormData = {};
  }
  shouldComponentUpdate(nextProps, nextState) {
    if (nextState !== this.state) {
      return true;
    } else {
      return false;
    }
  }

  update(slot, value) {
    if (slot === 'categories' && this.props.updateFeeByCategories !== undefined) {
      this.props.updateFeeByCategories(value);
    }

    this.globalFormData[slot] = value;
  }


  fetchDataAndRedirect() {
    var id = this.props.match.params['id'];
    const self = this;
    var headers = util.defaultHeaders();
    headers.append("Accept", "application/json");
    headers.append('Content-Type', 'application/x-www-form-urlencoded');
    var url = `/api/create-tender`;
    var promise = fetch(url, {
      method: 'POST',
      headers: headers,
      body: `id=${id}`
    })
      .then(response => response.json())
      .catch(function (exception) {
        alert('Konnte keine Werte laden!');
        console.error(`Could not retrieve tender data!`, exception);
      });
    promise.then(function (json) {
      self.setState({
        id: json.id,
        name: json.name,
        categories: json.categories,
        description: json.description,
        price: json.price,
        target_group: json.target_group,
        aim: json.aim,
        tags: json.tags,
        agb_agreement: json.agb_agreement,
        pdf_files: json.pdf_files,
        image_files: json.image_files,
        video_files: json.video_files,
        product_files: json.product_files,
        agreement_1: json.agreement_1,
        agreement_2: json.agreement_2,
        agreement_3: json.agreement_3,
        agreement_4: json.agreement_4,
      });
    })
  }

  isValid(categories) {

    if (categories === undefined)
      return false;

    if (categories === null)
      return false;

    if (categories === "")
      return false;

    if (typeof categories === 'string') {
      categories = categories.split(/,/);
    }

    var catInput = categories.map(item => parseInt(item, 10));
    for (var i = 0; i < categories.length; i++) {
      if (parseInt(catInput[i], 10) === catInput[i]) {
        return true;
      }
    }
    return false;
  }

  validateInput() {
    if (this.globalFormData['name'] === undefined) {
      if (this.state.name.length > 200) {
        alert("Der Name ist zu lang, bitte beschränken Sie sich auf 200 Zeichen.");
        return false;
      }
    } else {
      if (this.globalFormData['name'].length < 1) {
        alert("Der Name ist ein Pflichtfeld. Bitte geben Sie Ihrem Angebot einen Namen.");
        return false;
      }
      if (this.globalFormData['name'].length > 200) {
        alert("Der Name ist zu lang, bitte beschränken Sie sich auf 200 Zeichen.");
        return false;
      }
    }

    if (this.globalFormData['aim'] === undefined) {
      if (this.state.aim.length < 1) {
        alert("Der Zweck des Produktes ist ein Pflichtfeld. Bitte beschreiben Sie Ihr Angebot.");
        return false;
      }
      if (this.state.aim.length > 2000) {
        alert("Der Zweck des Produktes ist zu lang, bitte beschränken Sie sich auf 2000 Zeichen.");
        return false;
      }
    } else {
      if (this.globalFormData['aim'].length < 1) {
        alert("Der Zweck des Produktes ist ein Pflichtfeld. Bitte beschreiben Sie Ihr Angebot.");
        return false;
      }
      if (this.globalFormData['aim'].length > 2000) {
        alert("Der Zweck des Produktes ist zu lang, bitte beschränken Sie sich auf 2000 Zeichen.");
        return false;
      }
    }
    return true;
  }

  checkRequiredFields() {
    if (this.globalFormData['name'] === undefined) {
      if (this.state.name.length < 1) {
        alert("Der Name ist ein Pflichtfeld. Bitte geben Sie Ihrem Angebot einen Namen.");
        return false;
      }
    } else {
      if (this.globalFormData['name'].length < 1) {
        alert("Der Name ist ein Pflichtfelder. Bitte geben Sie Ihrem Angebot einen Namen.");
        return false;
      }
    }

    if ((this.globalFormData['categories'] === undefined) && (!this.isValid(this.state.categories))) {
      alert("Geben Sie wenigstens eine und bis zu sechs Kategorien an.");
      return false;
    }
    if (!this.isValid(this.globalFormData['categories'])) {
      alert("Geben Sie wenigstens eine und bis zu sechs Kategorien an.");
      return false;
    }

    if (this.globalFormData['aim'] === undefined) {
      if (this.state.aim.length < 1) {
        alert("Der Zweck ist ein Pflichtfeld. Bitte beschreiben Sie Ihr Angebot.");
        return false;
      }
    } else {
      if (this.globalFormData['aim'].length < 1) {
        alert("Der Zweck ist ein Pflichtfeld. Bitte beschreiben Sie Ihr Angebot.");
        return false;
      }
    }


    if (this.globalFormData['agreement_1'] === undefined) {
      if (this.state.agreement_1 !== true) {
        alert("Bitte stimmen Sie der Erklärung zu.");
        return false;
      }
    }

    if (this.globalFormData['agreement_1'] === false) {
      alert("Bitte stimmen Sie der Erklärung zu.");
      return false;
    }



    if (this.globalFormData['agreement_2'] === undefined) {
      if (this.state.agreement_2 !== true) {
        alert("Bitte stimmen Sie der Erklärung zu.");
        return false;
      }
    }

    if (this.globalFormData['agreement_2'] === false) {
      alert("Bitte stimmen Sie der Erklärung zu.");
      return false;
    }

    if (this.globalFormData['agreement_3'] === undefined) {
      if (this.state.agreement_3 !== true) {
        alert("Bitte stimmen Sie der Erklärung zu.");
        return false;
      }
    }

    if (this.globalFormData['agreement_3'] === false) {
      alert("Bitte stimmen Sie der Erklärung zu.");
      return false;
    }



    if (this.globalFormData['agreement_4'] === undefined) {
      if (this.state.agreement_4 !== true) {
        alert("Bitte stimmen Sie der Erklärung zu.");
        return false;
      }
    }

    if (this.globalFormData['agreement_4'] === false) {
      alert("Bitte stimmen Sie der Erklärung zu.");
      return false;
    }


    if (this.globalFormData['agb_agreement'] === false) {
      alert("Bitte bestätigen Sie, dass Sie die Vereinbarung zu Kenntnis genommen haben.");
      return false;
    }

    if (this.globalFormData['agb_agreement'] === undefined) {
      if (this.state.agb_agreement !== true) {
        alert("Bitte bestätigen Sie, dass Sie die Vereinbarung zu Kenntnis genommen haben.");
        return false;
      }
    }

    return true;
  }

  save(announce) {
    if (announce === true) {
      if (this.checkRequiredFields() === false) {
        return;
      }
    }

    if (announce === true) {
      if (this.validateInput() === false) {
        return;
      }
    }
    const self = this;
    var headers = util.defaultHeaders();
    headers.append("Accept", "application/json");
    var formData = new FormData();
    Object.keys(this.globalFormData).map(key => formData.append(key, self.globalFormData[key]));
    formData.append("id", this.state.id);
    if (announce === true) {
      formData.append('announce', true);
    } else {
      formData.append('announce', false);
    }
    formData.append('active', true);
    var url = `/api/update-tender`;
    var promise = fetch(url, {
      method: 'POST',
      headers: headers,
      body: formData
    })
      .then(response => response.json())
      .catch(function (exception) {
        alert('Konnte keine Werte speichern!');
        console.error(`Could not save tender data!`, exception);
      });
    promise.then(function (json) {
      alert('Werte wurden gespeichert.');
      if (announce === true) {
        logBusinessActivities("Ausschreibung gespeichert, allem zugestimmt und veroeffentlicht.", json.id);
      }
      self.globalFormData = {};
      self.setState({
        id: json.id,
        name: json.name,
        categories: json.categories,
        description: json.description,
        price: json.price,
        target_group: json.target_group,
        aim: json.aim,
        tags: json.tags,
        agb_agreement: json.agb_agreement,
        pdf_files: json.pdf_files,
        image_files: json.image_files,
        video_files: json.video_files,
        product_files: json.product_files,
        agreement_1: json.agreement_1,
        agreement_2: json.agreement_2,
        agreement_3: json.agreement_3,
        agreement_4: json.agreement_4,
      });
      self.props.history.push('/product-list');
    })
  }
  render() {
    return (
    <div>
      {util.isCommercialUser() &&
        <div className="Landing" id="contentId">
           <Header username={this.props.username} propagateLogin={this.props.propagateLogin} />
           <div className="ContentWithBackground">
           <div className="content" id="content">
               <div className="productHeader1">
                 Anbieten der Angebote über gelaufene Ausschreibungen
               </div>
        <div className="productHeader2">
        <TextInfo content={introductoryText} />
        </div>
        <div className="productForm1 marginTop30">
        <TextLine heading="Was bieten Sie an?" subheading="Unter diesem Titel wird ihr Produkt angezeigt." obligatory={true} maxLength='200' value={this.state.name} placeholder="was bieten Sie an" slot='name' update={this.update} />
        <TextField heading="Beschreibung" obligatory={true} maxLength='2000' placeholder="Zweck der Software" value={this.state.aim} slot='aim' update={this.update} />
        <CategorySelectorList value={this.state.categories} slot="categories" update={this.update} categoryLimit={6} />
        <TextLine heading="In welcher finanziellen Größenordnung bewegt sich Ihr Angebot?" obligatory={false} maxLength='50' value={this.state.price} slot='price' update={this.update} />
        <TextField heading="Bitte beschreiben Sie ausführlich noch einmal, was Sie anbieten." obligatory={false} maxLength='5000' placeholder="Beschreibung" value={this.state.description} slot='description' update={this.update} />
        <Selection heading="Für welche Einrichtung	ist das Produkt primär ausgelegt?"
          selectionValues={tenderTypes} obligatory={false} value={this.state.target_group} slot='target_group' update={this.update} />
        <Tags heading="Unter welchen Stichworten soll Ihr Angebot gefunden werden? Geben Sie bis zu sieben durch Komma getrennte Tags bzw. Stichworte ein." placeholder="Tags/Stichworte" value={this.state.tags} slot='tags' update={this.update} match={this.props.match} maxTags={7} maxLength={150} onNewMessage={this.props.onNewMessage} />
        <MultipleFileUpload heading="Dokumentation z.B. im PDF-Format (bitte nur fachliches Material)" subheading="Bitte wählen Sie zunächst die Dateien für den Upload von ihrem lokalen Rechner durch klicken auf ein freies Feld aus und drücken Sie danach Hochladen." value={this.state.pdf_files} slot="pdf_files" update={this.update} onNewMessage={this.props.onNewMessage} />
        <MultipleFileUpload heading="Beschreibende Bilder oder Screenshots zu dem Produkt" subheading="Ayacandas behält sich vor, die Auflösung von Bildern zu ändern, wenn diese ungewöhnlich viel Speicher brauchen sollten." value={this.state.image_files} slot="image_files" update={this.update} onNewMessage={this.props.onNewMessage} />
        <MultipleFileUpload heading="Ein Video mit maximal 5 GB Größe zum Produkt" value={this.state.video_files} slot="video_files" update={this.update} onNewMessage={this.props.onNewMessage} />
        <MultipleFileUpload heading="Hier haben Sie die Möglichkeit, Ihr Produkt als eine Datei hochzuladen." value={this.state.product_files} slot="product_files" update={this.update} onNewMessage={this.props.onNewMessage} />
        <CheckBox heading="* Erklärung zum Besitz" content="Bitte versichern Sie, dass das Angebotene entweder Ihnen gehört oder Sie oder Ihre Organisation die Urheberrechte auf das Angebotene besitzen." value={this.state.agreement_1} slot='agreement_1' update={this.update} />
        <CheckBox content="dass Sie nicht jemand anderes 'geistiges Eigentum' anbieten." value={this.state.agreement_2} slot='agreement_2' update={this.update} />
        <CheckBox content="dass Ihre Institution, für die Sie anbieten, mit dem Anbieten hier einverstanden ist." value={this.state.agreement_3} slot='agreement_3' update={this.update} />
        <CheckBox content="und dass Sie als Ansprechpartner für das Angebot zur Verfügung stehen werden." value={this.state.agreement_4} slot='agreement_4' update={this.update} />
        <AGBCheckBox value={this.state.agb_agreement} slot='agb_agreement' agbUrl="/einstellvertrag.pdf"
          content1="Ich habe den " fileType="Einstellvertrag" content2=" gelesen und akzeptiere diesen." update={this.update} /><br /><br />
        </div>
        <SubmitButton  history={this.props.history} onSubmit={this.save} />

      </div>
      </div>
      <Footer faqs={faqTender} />
      </div>
      
      }
       {!util.isCommercialUser() && 
        <div className="Landing" id="contentId">
       <Header username={this.props.username} propagateLogin={this.props.propagateLogin} />
           <div className="ContentWithBackground">
           <div className="content" id="content">
               <div className="productHeader1">Sie besitzen nicht genügend Rechte, um eine Ausschreibung zu erstellen.</div>
           </div>
           </div>
         <Footer faqs={faqTender} />
         </div>
         }
  </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/tender.js